export type UserPlanTier = 'free' | 'pro';

const PRO_SUBSCRIPTION_STATUSES = new Set(['active', 'trialing']);

export const getPlanTierFromSubscriptionStatus = (subscriptionStatus?: string | null): UserPlanTier => {
  const normalizedStatus = subscriptionStatus?.trim().toLowerCase();
  return normalizedStatus && PRO_SUBSCRIPTION_STATUSES.has(normalizedStatus) ? 'pro' : 'free';
};

export const isProPlanTier = (planTier?: UserPlanTier | null) => planTier === 'pro';
